import { EventEmitter, ElementRef } from '@angular/core';
var ComponentBtn = (function () {
    function ComponentBtn(el) {
        this.el = el;
        this.onExit = new EventEmitter(); //退出事件
        this.onCommit = new EventEmitter(); //提交事件
    }
    ComponentBtn.prototype.ngOnInit = function () {
    };
    ComponentBtn.prototype.ngAfterViewInit = function () {
    };
    // 按钮点击事件
    ComponentBtn.prototype.buttonHandleClick = function (i) {
        var target = this.el.nativeElement.querySelector('.button-' + i);
        // 如果提交按钮置灰并且这个按钮不是退出类型的按钮则不执行事件
        if (!target.classList.contains('cancel') && target.classList.contains('disabled')) {
            return false;
        }
        else {
            if (target.classList.contains('cancel')) {
                this.onExit.emit();
            }
            else {
                if (this.postData) {
                    this.onCommit.emit(this.postData);
                }
                else {
                    this.onCommit.emit();
                }
            }
        }
    };
    return ComponentBtn;
}());
export { ComponentBtn };



// WEBPACK FOOTER //
// ./src/component/button/component.button.ts.pre-build-optimizer.js